import { NavbarDesktop } from './NavbarDesktop';
import { NavbarMobile } from './NavbarMobile';

export function Navbar() {
  return (
    <>
      <NavbarMobile />
      <NavbarDesktop />
    </>
  );
}
